<template>
  <div class="dividend-share-page">
    <div class="ds-header">
      <div class="ds-title">众筹分红明细</div>
      <div class="ds-sub" v-if="data"> {{ lotteryName }} · {{ data.issueNumber || '-' }} 期</div>
    </div>

    <div v-loading="loading" class="ds-body">
      <template v-if="data">
        <!-- 基本信息卡 -->
        <div class="ds-card">
          <div class="ds-card-title">众筹信息</div>
          <div class="ds-row"><span class="k">众筹标题</span><span class="v">{{ data.title || '-' }}</span></div>
          <div class="ds-row"><span class="k">发起投注站</span><span class="v">{{ data.bettingShopAddress || '-' }}</span></div>
          <div class="ds-row"><span class="k">关联实战方案</span><span class="v">{{ data.schemeName || '未关联' }}</span></div>
          <div class="ds-row"><span class="k">众筹总额</span><span class="v">{{ money(data.crowdfundingAmount) }} 元</span></div>
          <div class="ds-row"><span class="k">总股数</span><span class="v">{{ data.totalShareNumber || 0 }} 股</span></div>
          <div class="ds-row"><span class="k">已认购</span><span class="v">{{ data.subscribedShareNumber || 0 }} 股</span></div>
        </div>

        <!-- 分红结果卡 -->
        <div class="ds-card highlight">
          <div class="ds-card-title">开奖分红</div>
          <div class="ds-row"><span class="k">税后中奖总额</span><span class="v">{{ money(data.afterTaxAmount) }} 元</span></div>
          <div class="ds-row"><span class="k">实战票盈亏总额</span>
            <span class="v" :class="Number(data.profitLossAmount) < 0 ? 'neg' : 'pos'">{{ money(data.profitLossAmount) }} 元</span>
          </div>
          <div class="ds-row big"><span class="k">每股分红</span><span class="v pos">{{ money(data.distributeBonus) }} 缩币</span></div>
          <div class="ds-row"><span class="k">应分红总额</span><span class="v">{{ money(data.totalPayableAmount) }} 缩币</span></div>
          <div class="ds-formula" v-if="data.profitLossFormula">盈亏计算：{{ data.profitLossFormula }}</div>
          <div class="ds-formula" v-if="data.dividendFormula">分红计算：{{ data.dividendFormula }}</div>
        </div>

        <!-- 分红明细表 -->
        <div class="ds-card">
          <div class="ds-card-title">分红清单</div>
          <div class="ds-table-head ds-tr">
            <span class="td-name">用户</span>
            <span class="td-num">股数</span>
            <span class="td-amt">分红(缩币)</span>
            <span class="td-st">状态</span>
          </div>
          <div class="ds-tr" v-for="(p, i) in (data.purchaserList || [])" :key="i">
            <span class="td-name">{{ maskName(p.purchaser) }}</span>
            <span class="td-num">{{ p.purchaserNumber || 0 }}</span>
            <span class="td-amt">{{ money(p.dividendAmount) }}</span>
            <span class="td-st" :class="p.bonusStatus == '1' || p.bonusStatus == '2' ? 'ok' : 'wait'">
              {{ p.bonusStatusIntro || '待派奖' }}
            </span>
          </div>
          <div v-if="!(data.purchaserList || []).length" class="ds-empty">暂无认购记录</div>
        </div>

        <div class="ds-footer">分红状态以投注站实际派奖凭证为准</div>
      </template>

      <div v-else-if="!loading" class="ds-empty">未获取到分红数据，请联系发起人。</div>
    </div>
  </div>
</template>

<script>
import { bettingShopShareDividendDetail } from "@/api/apply";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "DividendShare",
  data() {
    return {
      loading: false,
      data: null,
    };
  },
  computed: {
    lotteryName() {
      const t = this.data && this.data.lotteryType;
      return LOTTERY_MAP[t] || t || '-';
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (!id) {
      this.$message && this.$message.warning("缺少众筹 ID");
      return;
    }
    this.load(id);
  },
  methods: {
    load(id) {
      this.loading = true;
      bettingShopShareDividendDetail(id)
        .then((res) => {
          const d = res && res.data !== undefined ? res.data : res;
          this.data = d && typeof d === 'object' ? d : null;
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    maskName(name) {
      const s = String(name == null ? '' : name);
      if (s.length <= 2) return s.charAt(0) + '*';
      return s.charAt(0) + '*'.repeat(s.length - 2) + s.charAt(s.length - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.dividend-share-page {
  min-height: 100vh;
  background: #f2f6fb;
  padding-bottom: 30px;
}

.ds-header {
  background: linear-gradient(135deg, #2a7ce0, #347caf);
  color: #fff;
  padding: 22px 16px 18px;
  text-align: center;

  .ds-title { font-size: 20px; font-weight: bold; }
  .ds-sub { margin-top: 6px; font-size: 13px; opacity: .9; }
}

.ds-body { padding: 12px; }

.ds-card {
  background: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 6px rgba(31, 56, 88, .06);

  &.highlight { border-left: 4px solid #e6a23c; }

  .ds-card-title {
    font-size: 15px;
    font-weight: bold;
    color: #347caf;
    margin-bottom: 10px;
  }
}

.ds-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 14px;

  .k { color: #8a94a6; }
  .v { color: #2c3547; font-weight: 500; text-align: right; }
  .pos { color: #d8452e; }
  .neg { color: #1ea06a; }

  &.big {
    .v { font-size: 18px; font-weight: bold; }
  }
}

.ds-formula {
  margin-top: 8px;
  padding: 8px 10px;
  background: #f7f9fc;
  border-radius: 6px;
  font-size: 12px;
  color: #6b7688;
  line-height: 1.6;
  word-break: break-all;
}

.ds-tr {
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px solid #f0f2f5;

  &:last-of-type { border-bottom: none; }

  .td-name { flex: 1.4; color: #2c3547; word-break: break-all; }
  .td-num { flex: .7; text-align: center; color: #2c3547; }
  .td-amt { flex: 1; text-align: center; color: #d8452e; font-weight: 500; }
  .td-st { flex: 1; text-align: right; font-size: 12px; }

  .ok { color: #1ea06a; }
  .wait { color: #b0b8c5; }
}

.ds-table-head {
  color: #8a94a6;
  font-size: 12px;
  border-bottom: 1px solid #e8ecf2;
}

.ds-empty {
  text-align: center;
  color: #8a94a6;
  font-size: 13px;
  padding: 24px 0;
}

.ds-footer {
  text-align: center;
  color: #a5aebc;
  font-size: 12px;
  padding: 10px 0 0;
}
</style>
